module.exports = __webpack_public_path__ + "static/media/feature-cta.928cce1c.png";